"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _server = require("react-dom/server");

var en = 'en';
/** For setting up react-localize-redux */

var LocalizationInitializer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LocalizationInitializer, _React$Component);

  function LocalizationInitializer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LocalizationInitializer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LocalizationInitializer).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchLocalizationsByCodes", function () {
      var cultureCodes = _this.getCultureCodes();

      var fetches = cultureCodes.map(_this.fetchLocalizations);
      Promise.all(fetches).then(function (translations) {
        _this.initializeLocalization(translations, cultureCodes);

        _this.setState({
          isLoadingTranslations: false
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchLocalizations", function (code) {
      var keys = _this.getLocalizationKeys();

      var url = _this.props.localizationApiUrl;
      var localizationUrl = "".concat(url, "/").concat(code);

      var options = _this.getFetchOptions(keys);

      return fetch(localizationUrl, options).then(function (response) {
        return response.json();
      }).then(function (translations) {
        return _this.getLocalizationsDictionary(translations);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFetchOptions", function (localizationKeys) {
      var defaultOptions = {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(localizationKeys)
      };
      return (0, _objectSpread2.default)({}, defaultOptions, _this.props.fetchOptionsOverride);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCultureCodes", function () {
      var params = new URLSearchParams(_this.props.location.search);
      var code = params.get(_this.props.cultureCodeQueryParamName);
      if (!code || code === en) return [en];
      return [code, en];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initializeLocalization", function (translations, cultureCodes) {
      var translation = _this.getTranslationDictionary(translations);

      _this.props.initialize({
        translation: translation,
        languages: cultureCodes,
        options: {
          renderToStaticMarkup: _server.renderToStaticMarkup
        }
      });
    });
    _this.state = {
      isLoadingTranslations: true
    };

    if (!props.localizationApiUrl) {
      throw new Error('LocalizationInitializer: props.localizationApiUrl should provide a valid URL for the Treeline Localization service');
    }

    return _this;
  }

  (0, _createClass2.default)(LocalizationInitializer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children(this.state) : children;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchLocalizationsByCodes();
    }
  }, {
    key: "getLocalizationKeys",
    value: function getLocalizationKeys() {
      return this.props.localizationKeys;
    }
  }, {
    key: "getLocalizationsDictionary",
    value: function getLocalizationsDictionary(localizationsArr) {
      return localizationsArr.reduce(function (dictionaryAggregate, localization) {
        dictionaryAggregate[localization.key] = localization.value;
        return dictionaryAggregate;
      }, {});
    }
  }, {
    key: "getTranslationDictionary",
    value: function getTranslationDictionary(translations) {
      if (translations.length === 1) return translations[0];
      var globalTranslations = {};
      Object.keys(translations[0]).forEach(function (key) {
        var defaultTranslation = translations[0][key];
        var secondaryTranslation = translations[1][key];
        globalTranslations[key] = [defaultTranslation, secondaryTranslation];
      });
      return globalTranslations;
    }
  }]);
  return LocalizationInitializer;
}(_react.default.Component);

exports.default = LocalizationInitializer;
LocalizationInitializer.propTypes = {
  /** the localization keys to fetch from the localization service API */
  localizationKeys: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /** The URL to the translation api service */
  localizationApiUrl: _propTypes.default.string.isRequired,

  /** ({ isLoadingTranslations }) => Jsx or just a react element if you don't care about the loading state */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]).isRequired,

  /** Overrides for the options passed to the browser fetch API */
  fetchOptionsOverride: _propTypes.default.object,

  /** The name of the query string parameter that identifies the language culture code */
  cultureCodeQueryParamName: _propTypes.default.string,

  /** Use withRouter() from react-router-dom to add this prop */
  location: _propTypes.default.object.isRequired,

  /** Use withLocalize() from react-localize-redux to add this prop */
  initialize: _propTypes.default.func.isRequired
};
LocalizationInitializer.defaultProps = {
  localizationKeys: [],
  fetchOptionsOverride: {},
  cultureCodeQueryParamName: 'cultureCode'
};